import React, { useContext, useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import StateContext from '../context/state/StateContext';

const Success = () => {
    const [windowDimension, setWindowDimension] = useState({ width: window.innerWidth, height: window.innerHeight });
    const { success, setSuccess } = useContext(StateContext);
    const [isVisible, setIsVisible] = useState(false); // Manages opacity state

    const detectSize = () => {
        setWindowDimension({ width: window.innerWidth, height: window.innerHeight });
    };

    // Listen for window resize to adjust Confetti size
    useEffect(() => {
        window.addEventListener("resize", detectSize);
        return () => {
            window.removeEventListener("resize", detectSize);
        };
    }, []);

    // Handle visibility with fade-out effect
    useEffect(() => {
        if (success) {
            setIsVisible(true); // Show confetti
            const timeout = setTimeout(() => {
                setIsVisible(false); // Fade out
                setTimeout(() => {
                    setSuccess(false); // Remove confetti after fade-out
                }, 1000); // Time for the opacity transition
            }, 5000);

            // Cleanup timeout
            return () => clearTimeout(timeout);
        }
    }, [success, setSuccess]);

    return (
        <>
            {success && (
                <div
                    style={{
                        opacity: isVisible ? 1 : 0, // Transition between visible and invisible
                        transition: 'opacity 1s ease-out', // 1 second fade-out effect
                        zIndex: "9999999",
                    }}
                >
                    <Confetti width={windowDimension.width} height={windowDimension.height} style={{zIndex: "9999999"}} />
                </div>
            )}
        </>
    );
};

export default Success;
